import React, { useState, useEffect, useContext } from 'react';
import dayjs from 'dayjs';
import cls from 'classnames';
import { useHistory } from 'react-router-dom';

import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import observableToUseEffect from 'venuescanner-js/react/components/Inbox/utils/observableToUseEffect';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';
import countries from 'venuescanner-js/constants/countries.json';
import UserTypes from 'venuescanner-js/constants/user_type';

import Avatar from 'venuescanner-js/react/components/Inbox/components/Objects/Avatar';
import EnquiryStatus from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryStatus';

const EnquiryThumbnail = props => {
  const { thread } = props;
  const { activeThread, isMobileDevice, setActiveCurrency } =
    useContext(ViewContext);
  const [showDataFor] = useState(
    thread._subjects._value.thread.viewerRole === UserTypes.organiser
      ? UserTypes.host
      : UserTypes.organiser,
  );
  const [threadPreview, setThreadPreview] = useState(null);
  let history = useHistory();
  useEffect(() => {
    return observableToUseEffect({ thread }, ({ thread }) =>
      setThreadPreview(thread),
    );
  }, [thread]);

  useEffect(() => {
    if (threadPreview?.venue?.country_code)
      setActiveCurrency(countries[threadPreview.venue.country_code]);
  }, [threadPreview]);

  const handleClick = async () => {
    await inboxService.loadThread(threadPreview.thread._id);
    history.push(`/inbox/${threadPreview.thread._id}`);
  };

  if (!threadPreview) return null;
  const concierge = threadPreview.concierge
    ? threadPreview.concierge.name
    : null;
  const venueNames = threadPreview.venue.name.split(' ');
  const firstName = threadPreview[showDataFor]?.name || null;
  const lastName = threadPreview[showDataFor]?.lastName || null;
  const hostName =
    firstName || lastName
      ? [firstName, lastName].filter(n => !!n).join(' ')
      : 'Host';
  const names = [];
  if (firstName) names.push(firstName);
  if (lastName) names.push(lastName);
  if (!names.length) {
    while (names.length < 2 && venueNames.length > 0) {
      names.push(venueNames.shift());
    }
  }
  const imageUrl = threadPreview[showDataFor]?.profile_photo
    ? threadPreview[showDataFor]?.profile_photo !== '[object Object]'
      ? `https://cdn.venuescanner.com/${threadPreview[showDataFor].profile_photo}`
      : null
    : null;
  const alert = threadPreview.thread[
    'unread_' + threadPreview.thread.viewerRole
  ]
    ? 'unread'
    : false;

  return (
    <div
      className={cls('enquiry-thumbnail', {
        isActive:
          !isMobileDevice &&
          threadPreview.thread._id === activeThread?.data()._id,
      })}
      onClick={() => handleClick()}>
      <Avatar
        names={names}
        size='medium'
        alert={alert}
        imageUrl={imageUrl}
        concierge={concierge}
      />
      <div className='enquiry-thumbnail__details'>
        <div className='enquiry-thumbnail__row'>
          <span
            className={cls(
              'enquiry-thumbnail__name enquiry-thumbnail__spacer',
              {
                h6: isMobileDevice,
                h4: !isMobileDevice,
              },
            )}>
            {hostName}
          </span>
          <div className='enquiry-thumbnail__row'>
            <EnquiryStatus thread={threadPreview.thread} />
          </div>
        </div>
        <div className='enquiry-thumbnail__row'>
          <span className='enquiry-thumbnail__info enquiry-thumbnail__spacer'>
            {threadPreview.venue.name}
          </span>
          <span
            className={cls('enquiry-thumbnail__date', {
              'enquiry-thumbnail__date--passed': dayjs().isBefore(
                dayjs(threadPreview.thread.localDates.from),
              ),
            })}>
            {dayjs(threadPreview.thread.localDates.from).format('DD/M/YYYY')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EnquiryThumbnail;
